import { DI } from '@intigral/constant/config/DIContainer';
import { IValidateVOCTokenUseCase } from '../../core/usecases/notifications/ValidateVOCTokenUseCase';
import { container } from '../../DataDomain';
import { IFormSignatureObjectUseCase } from '../../core/usecases/auth/FormSignatureObjectUseCase';

export interface INotificationsService {
    validateVOCToken(token: string): Promise<any['data']>;
}

export class NotificationsService implements INotificationsService {
    // Lazy getter for dependency to avoid circular dependencies
    private get validateVOCTokenUseCase(): IValidateVOCTokenUseCase {
        return container.resolve<IValidateVOCTokenUseCase>(DI.USECASES.IValidateVOCTokenUseCase);
    }
    private get formSignatureObjectUseCase(): IFormSignatureObjectUseCase {
        return container.resolve<IFormSignatureObjectUseCase>(DI.USECASES.IFormSignatureObjectUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async validateVOCToken(token: string): Promise<any['data']> {
        const csrfToken = await this.formSignatureObjectUseCase.execute();
        if (!csrfToken) {
            throw new Error('Invalid API token');
        }
        return await this.validateVOCTokenUseCase.execute(token, csrfToken);
    }
}
